// ترجماتُ المجموعة 2 — تُملأ بترجمة صفحاتها (2026-10-03). المفتاح: النصُّ العربيّ كما في tt().
const EN_B2: Record<string, string> = {
  "آخر 7 أيام": "Last 7 days",
  "التوكنات اليومية": "Daily Tokens",
  "أعلى العملاء استهلاكاً": "Top Customers by Usage",
  "لا توجد بيانات استهلاك بعد": "No usage data yet",
  "التوكنات": "Tokens",
  "الطلبات": "Requests",
  "إجمالي التوكنات": "Total Tokens",
  "عدد الطلبات": "Requests",
  "توكنات الإدخال": "Input Tokens",
  "توكنات الإخراج": "Output Tokens",
  "قنوات مراسلة": "Messaging channels",
  "فروع/شركات": "Branches/companies",
  "مستخدمين": "Users",
  "توكنات ذكاء اصطناعي شهرياً": "AI tokens per month",
  "أنشئ حساب شركتك في جسر CRM": "Create your company account on Jisr CRM",
  "أنشئ حساب شركتك مجّاناً": "Create your company account for free",
  "اختر باقتك، ادفع، ويتفعّل حسابك تلقائياً خلال ثوانٍ.": "Choose your plan, pay, and your account activates automatically within seconds.",
  "املأ البيانات ويتفعّل حسابك خلال ثوانٍ.": "Fill in your details and your account activates within seconds.",
  "اشترك وادفع": "Subscribe & Pay",
  "أنشئ الحساب": "Create Account",
  "جارٍ التحويل للدفع…": "Redirecting to payment…",
  "جارٍ إنشاء الحساب…": "Creating account…",
  "بالضغط على «اشترك وادفع» تُحوّل لبوابة دفع آمنة (KNET / Apple Pay)، ويُفعّل حسابك فور نجاح الدفع.": "By clicking “Subscribe & Pay” you will be redirected to a secure payment gateway (KNET / Apple Pay), and your account activates once payment succeeds.",
  "يُنشأ حسابك فوراً — بلا أي دفع.": "Your account is created instantly — no payment needed.",
  "التسجيل الذاتي غير مفعّل حالياً. تواصل معنا لإنشاء حسابك.": "Self sign-up is currently disabled. Contact us to create your account.",
  "تعذّر تحميل الباقات": "Failed to load plans",
  "أدخل اسم الشركة": "Enter the company name",
  "اختر باقة": "Choose a plan",
  "البريد الإلكتروني غير صحيح": "Invalid email address",
  "كلمة المرور يجب أن تكون 6 أحرف على الأقل": "Password must be at least 6 characters",
  "تعذّر بدء التسجيل": "Could not start sign-up",
  "تعذّر الاتصال بالخادم": "Could not connect to the server",
  "اختر الباقة": "Choose a Plan",
  "لا توجد باقات متاحة حالياً.": "No plans available right now.",
  "شهرياً · 30 يوماً": "Monthly · 30 days",
  "بيانات الشركة والمدير": "Company & Admin Details",
  "اسم الشركة *": "Company name *",
  "اسم المدير": "Admin name",
  "البريد الإلكتروني *": "Email *",
  "كلمة المرور * (6 أحرف فأكثر)": "Password * (6+ characters)",
  "رقم الجوال": "Mobile number",
  "عندك حساب؟ سجّل الدخول ←": "Have an account? Sign in →",
  "{h} س {m} د": "{h}h {m}m",
  "{h} س": "{h}h",
  "{m} د": "{m}m",
  "تعذر تحميل رابط الرحلة": "Failed to load the trip link",
  "الرابط غير متاح": "Link unavailable",
  "جاري تحميل الرحلة...": "Loading trip...",
  "مقدّم من": "Provided by",
  "تسجيل رحلة": "Trip Recording",
  "عدد الرحلات": "Trips",
  "المسافة": "Distance",
  "وقت القيادة": "Driving time",
  "أعلى سرعة": "Top speed",
  "لا توجد بيانات GPS لهذه الفترة": "No GPS data for this period",
  "إيقاف": "Pause",
  "تشغيل": "Play",
  "حد": "Limit",
  "عرض التسجيل كاملاً": "Show full recording",
  "أعلى {n} كم/س": "Max {n} km/h",
  "بداية التسجيل": "Recording start",
  "نهاية التسجيل": "Recording end",
  "عدد نقاط GPS": "GPS points",
  "{n} نقطة": "{n} points",
  "السرعة الحالية": "Current speed",
  "الموقع الحالي": "Current location",
  "فتح الموقع في Google Maps": "Open location in Google Maps",
  "ينتهي الرابط في {d}": "Link expires on {d}",
  "تحليل السيّارة": "Vehicle Analysis",
  "قرار النظام": "System decision",
  "قرار الإدارة": "Management decision",
  "درجة الصحّة": "Health score",
  "للفرز والنظرة السريعة — القرارُ أعلاه هو الحكم": "For sorting and a quick look — the decision above is what counts",
  "لماذا هذا القرار": "Why this decision",
  "الإيراد": "Revenue",
  "قيمة العقود": "Contract value",
  "المحصَّل": "Collected",
  "غير المحصَّل": "Uncollected",
  "نسبة التحصيل": "Collection rate",
  "الربحيّة": "Profitability",
  "الإداريّ": "Admin",
  "صافٍ/شهر": "Net/month",
  "قبضٌ/شهر": "Collected/month",
  "مقارنة الفترات": "Period Comparison",
  "٣ أشهر": "3 months",
  "الثلاثة السابقة": "Previous 3",
  "٦ أشهر": "6 months",
  "١٢ شهراً": "12 months",
  "العمر كلّه": "Lifetime",
  "الصيانة ٪": "Maintenance %",
  "التمويل": "Financing",
  "نقداً": "Cash",
  "قرض": "Loan",
  "الجهة": "Lender",
  "المسدَّد": "Paid",
  "القسط": "Installment",
  "البداية": "Start",
  "النهاية": "End",
  "القرض/القيمة": "Loan/value",
  "اقتصاد الخروج": "Exit Economics",
  "سعرٌ منخفض": "Low price",
  "الأساس": "Base",
  "سعرٌ مرتفع": "High price",
  "تكلفة الخروج": "Exit cost",
  "هامش الأمان": "Safety margin",
  "الكاش بعد البيع": "Cash after sale",
  "البيع يغطّي القرضَ والتكلفةَ والهامش": "The sale covers the loan, costs and margin",
  "البيع لا يغطّي": "The sale does not cover it",
  "لا سعرَ سوقٍ مُدخَل — لا حكمَ على الجدوى": "No market price entered — no verdict on feasibility",
  "التقييم": "Valuation",
  "سجلّ الصيانة": "Maintenance Log",
  "سجلّ القبض": "Collections Log",
  "سجلّ القرار": "Decision History",
  "المصدر": "Source",
  "الإدارة": "Management",
  "تجاوز قرار النظام": "Override System Decision",
  "القرارُ الأصليّ يبقى معروضاً — التجاوزُ لا يمحوه": "The original decision stays visible — an override does not erase it",
  "السبب (إلزاميّ)": "Reason (required)",
  "اعتماد قرار الإدارة": "Apply management decision",
  "رفع التجاوز": "Remove override",
  "يُحفظ…": "Saving…",
  "لا صفوف": "No rows",
  "البند": "Item",
  "اكتمال البيان": "Data completeness",
  "بيع الآن": "Sell now",
  "تجهيز للبيع": "Prepare to sell",
  "مراقبة": "Monitor",
  "أبقِ": "Keep",
  "بيانات غير كافية": "Insufficient data",
  "بلا دخل": "no income",
  "تعذّر التحميل": "Failed to load",
  "تعذّر الحفظ": "Failed to save",
  "معاملة جديدة": "New Errand",
  "تعديل «{t}»": "Edit “{t}”",
  "نوع المعاملة": "Errand type",
  "اسم المعاملة": "Errand name",
  "يُملأ من النوع — غيّره إن احتجت": "Filled from the type — change it if needed",
  "المرور / البلدية / وزارة التجارة / الإطفاء…": "Traffic / Municipality / Ministry of Commerce / Fire Dept…",
  "الموظّفون الموكَّلون": "Assigned employees",
  "بلا توكيل": "Unassigned",
  "اختر واحداً أو أكثر — كلُّهم يرون المعاملة ويصلهم التذكير، وأيُّهم أقفلها أقفلها للجميع": "Choose one or more — all of them see the errand and get reminders, and whoever closes it closes it for everyone",
  "موظّف واحد": "1 employee",
  "{n} موظّفين": "{n} employees",
  "الموعد": "Due date",
  "التذكير قبل الموعد بـ": "Remind before due date by",
  "رقم المرجع، المطلوب من الأوراق، أي تفاصيل…": "Reference number, required documents, any details…",
  "تُنشأ معاملة مستقلّة لكل سيارة — تُنجَز وتُقفل كلٌّ على حدة": "A separate errand is created for each car — each is completed and closed on its own",
  "ابحث بلوحة أو اسم…": "Search by plate or name…",
  "لا توجد سيارات": "No cars",
  "سيارة واحدة": "1 car",
  "{n} سيارات": "{n} cars",
  "اختيار المعروض": "Select shown",
  "مسح الاختيار": "Clear selection",
  "جاري تحميل السيارات…": "Loading cars…",
  "منتهٍ منذ {n} يوم": "Expired {n} days ago",
  "باقي {n} يوم": "{n} days left",
  "بلا تاريخ": "No date",
  "من الشامل": "From comprehensive",
  "عليها معاملة": "Has an errand",
  "تُجوهلت {n} — عليها معاملة مفتوحة من النوع نفسه": "{n} skipped — they already have an open errand of the same type",
  "مخفيّة {n} سيارة خارجة من الأسطول (مباعة أو موقوفة)": "{n} cars hidden that are out of the fleet (sold or suspended)",
  "ما فيه تواريخ مسجّلة لهذا النوع — الاختيار شغّال، بس بلا ترتيب بالأقرب انتهاءً": "No dates recorded for this type — selection works, but without sorting by nearest expiry",
  "أنشئ معها معاملة «فحص فنّي»": "Also create a “Technical inspection” errand",
  "قبل الموعد بأسبوع، على نفس السيارة ونفس الموظّف — ارفع العلامة إن ما تحتاجها": "One week before the due date, for the same car and employee — uncheck if you don't need it",
  "اختر سيارة واحدة على الأقل": "Choose at least one car",
  "جارٍ الحفظ…": "Saving…",
  "اسم المعاملة مطلوب": "Errand name is required",
  "فشل التحميل": "Failed to load",
  "حذف معاملة «{t}» نهائياً؟": "Permanently delete errand “{t}”?",
  "إنجاز": "Complete",
  "إعادة فتح": "Reopen",
  "بدء التنفيذ": "Start",
  "جاري تحميل المعاملات…": "Loading errands…",
  "لا توجد معاملات": "No errands",
  "أضف معاملة، وكّل عليها موظّفاً، وحدّد موعدها — وجسر يذكّره على الواتساب حتى ينجزها": "Add an errand, assign an employee and set its due date — Jisr reminds them on WhatsApp until it's done",
  "ما عندك معاملات موكَّلة لك": "You have no errands assigned to you",
  "المعاملات التي يوكّلك عليها المدير تظهر هنا": "Errands your manager assigns to you appear here",
  "بلا موكَّل": "Unassigned",
  "بلا موعد": "No due date",
  "بلا رقم واتساب": "No WhatsApp number",
  "ما يوصلهم تذكير: {names}": "Won't receive reminders: {names}",
  "ما يوصله تذكير — أضف رقمه في «إدارة الفريق»": "No reminder will reach them — add their number in “Team Management”",
  "ما عنده صلاحية المعاملات": "No access to errands",
  "يوصله التذكير بس ما يقدر يفتح الشاشة ليقفلها — امنحه «معاملات الشركة» في إدارة الفريق": "They get the reminder but can't open the screen to close it — grant “Company Errands” in Team Management",
  "{n} معاملة متأخّرة عن موعدها": "{n} errands overdue",
  "{n} معاملة قرب موعدها": "{n} errands due soon",
  "كل المعاملات ضمن مواعيدها ✓": "All errands are on schedule ✓",
  "يوصل التذكير على واتساب الموظّف الموكَّل يومياً حتى تُنجَز — رسالة واحدة تجمع كل معاملاته — ويصل المدير والمشرف ملخّص ما تأخّر": "A daily reminder goes to the assigned employee's WhatsApp until it's done — one message covering all their errands — and the manager and supervisor get a summary of what's overdue",
  "بلا موعد لا يصلها تذكير — حدّد موعداً ليعمل التذكير (تظهر للمدير في ملخّص «بلا موعد»)": "Without a due date there's no reminder — set a date to enable reminders (it shows to the manager in the “No due date” summary)",
  "إظهار المنجزة": "Show completed",
  "إخفاء المنجزة": "Hide completed",
  "ملاحظة": "Note",
  "اكتب ما وصلت إليه في هذه المعاملة — يقرأها المدير في الصفحة:": "Write your progress on this errand — the manager reads it on the page:",
  "إرفاق صورة": "Attach image",
  "جارٍ الرفع…": "Uploading…",
  "تعذّر إرفاق الصورة": "Failed to attach image",
  "أُضيفت معاملة": "Errand added",
  "أُضيفت {n} معاملات": "{n} errands added",
  "جديدة": "New",
  "منجزة": "Completed",
  "أُنجزت {d}": "Completed {d}",
  "متأخّرة {n} يوم — {d}": "{n} days overdue — {d}",
  "موعدها اليوم — {d}": "Due today — {d}",
  "باقي {n} يوم — {d}": "{n} days left — {d}",
  "الموعد {d} (باقي {n} يوم)": "Due {d} ({n} days left)",
  "{n} يوم": "{n} days",
  "تذكير قبل {n} يوم": "Reminder {n} days before",
  "لم تُضف بعد": "Not added yet",
  "لم يُضف بعد": "Not added yet",
  "منتهية منذ {n} يوم": "Expired {n} days ago",
  "ينتهي بعد {n} يوم": "Expires in {n} days",
  "سارية": "Valid",
  "ساري": "Valid",
  "متبقٍ {n} يوم": "{n} days left",
  "مؤجّرة الآن": "Rented now",
  "خروجية": "Out",
  "غير منشورة": "Unpublished",
  "تعديل السيارة": "Edit Car",
  "إضافة صور": "Add photos",
  "إيقاف النشر": "Unpublish",
  "نشر السيارة": "Publish car",
  "حذف السيارة": "Delete car",
  "تمت إضافة سيارة جديدة": "New car added",
  "تم حفظ التعديلات ✅": "Changes saved ✅",
  "تم رفع الملف ✅": "File uploaded ✅",
  "تم تعيين الصورة الرئيسية": "Main photo set",
  "حذف \"{name}\"؟ هذا الإجراء لا يمكن التراجع عنه.": "Delete \"{name}\"? This action cannot be undone.",
  "تعذّر الحذف": "Could not delete",
  "خطأ غير متوقع": "Unexpected error",
  "حُذفت السيارة \"{name}\"": "Car \"{name}\" deleted",
  "إدارة السيارات": "Car Management",
  "أدر بروفايل كل سيارة — الصور، السعر، المواصفات، الوثائق وحالة التوفّر": "Manage each car's profile — photos, price, specs, documents and availability",
  "إضافة سيارة": "Add Car",
  "ابحث باسم السيارة، الماركة، رقم اللوحة أو المستأجر…": "Search by car name, brand, plate number or renter…",
  "الأحدث إضافة": "Newest first",
  "الأعلى سعراً": "Highest price",
  "الأقل سعراً": "Lowest price",
  "الأقرب انتهاءً للوثائق": "Documents expiring soonest",
  "بطاقات": "Cards",
  "جدول": "Table",
  "لا توجد سيارات مطابقة للبحث أو الفلتر": "No cars match the search or filter",
  "بدون صور": "No photos",
  "د.ك/يوم": "KWD/day",
  "د.ك/ساعة": "KWD/hour",
  "د.ك/شهر": "KWD/month",
  "الموديل": "Model",
  "اللون": "Color",
  "الجير": "Transmission",
  "الوقود": "Fuel",
  "أبرز المواصفات": "Key Features",
  "+{n} مواصفة": "+{n} features",
  "تأمين شامل": "Comprehensive insurance",
  "الاستمارة (ضد الغير)": "Registration (third-party)",
  "السعر": "Price",
  "الصور والفيديو": "Photos & Video",
  "رئيسية": "Main",
  "تعيين رئيسية": "Set as main",
  "مثال: 12345 ك ف": "e.g. 12345 KF",
  "— بدون شركة —": "— No company —",
  "الفرع": "Branch",
  "— بدون فرع —": "— No branch —",
  "— غير محدد —": "— Not specified —",
  "انتهاء الاستمارة/ضد الغير (يدوي — لغير المزامنة من Drive8)": "Registration/third-party expiry (manual — for cars not synced from Drive8)",
  "رقم الشاصي (اختياري)": "Chassis number (optional)",
  "VIN / رقم الهيكل": "VIN / chassis number",
  "وحدة التأجير": "Rental unit",
  "بالساعة": "Hourly",
  "باليوم": "Daily",
  "السعر الأساسي (د.ك/يوم)": "Base price (KWD/day)",
  "السعر الأساسي (د.ك/ساعة)": "Base price (KWD/hour)",
  "أبرز المواصفات (كاميرا 360، شاشة، مقاعد جلد…)": "Key features (360 camera, screen, leather seats…)",
  "لا مواصفات مضافة": "No features added",
  "اكتب مواصفة واضغط إضافة أو Enter": "Type a feature and press Add or Enter",
  "الوصف (يستخدمه AI للتسويق)": "Description (used by AI for marketing)",
  "مثال: سيارة فاخرة مريحة، تسع 6 ركاب، مناسبة للمطار والمناسبات...": "e.g. A comfortable luxury car, seats 6, ideal for airport trips and occasions...",
  "جدول الأسعار": "Pricing Table",
  "تأكيد مسح جدول الأسعار؟": "Confirm clearing the pricing table?",
  "مسح الأسعار": "Clear prices",
  "إضافة سعر": "Add price",
  "أوتوماتيك": "Automatic",
  "عادي": "Manual",
  "بنزين": "Petrol",
  "ديزل": "Diesel",
  "هايبرد": "Hybrid",
  "توقيت سجلات الجهاز متأخر بساعات — الجهاز يعيد إرسال رحلات قديمة خزّنها أثناء انقطاعه، أو ساعته غير مضبوطة. الموقع والسرعة المعروضان": "The device's record timestamps are hours behind — it is resending old trips stored while disconnected, or its clock is wrong. The location and speed shown are",
  "وقد لا يمثلان مكان السيارة الآن. تصحّح نفسها عادةً بعد اكتمال إرسال السجلات المخزنة؛ إن استمرت أعد تشغيل الجهاز وافحص هوائي GPS والشريحة.": "and may not reflect where the car is now. This usually corrects itself once the stored records finish sending; if it persists, restart the device and check the GPS antenna and SIM.",
  "المحرّك": "Engine",
  "يعمل": "Running",
  "غير معروف": "Unknown",
  "إجمالي الأسطول": "Total Fleet",
  "تنبيهات الوثائق": "Document Alerts",
};
export default EN_B2;
